import { Category } from "src/pages/OfferPage/FunctionDescription/Category/Category";
import { ClientType } from "src/api/v1/project-ApiSlice";

export const FunctionDescription = (props: { functionDescription: any, clientType: ClientType}) => {
  const { functionDescription, clientType } = props;

  return functionDescription ? (
    <div className="break-before">
      {Object.keys(functionDescription).map((category, categoryKey) => (
        <Category
          key={categoryKey}
          category={functionDescription[category]}
          clientType={clientType}
        />
      ))}
    </div>
  ) : null;
};
